export const INDEX = "/";
export const SETTINGS = "/settings";
export const EXPORT = "/export";
export const LOGIN = "/login";
export const SCAN = "/scan";
export const ITEM = "/item";
export const CENSUS = "/census";
export const HISTORY = "/history";
export const WAREHOUSE = "/warehouse";
export const VISITOR = "/visitor";
